module.exports = __webpack_public_path__ + "static/media/left_illustration.8de78baa.svg";